import EA from '../helpers/init';

export default EA.Methods.accordionHandler = ($this) => {
    const accordionItems = $this.querySelectorAll('.accordion-item');

    accordionItems.forEach((item, index) => {
        item.querySelector('.accordion-header').addEventListener('click', () => {
            const currentlyActiveGif = $this.parentNode.querySelector('.gif.active');

            if(currentlyActiveGif) {
                currentlyActiveGif.classList.remove('active');
            }

            $this.parentNode.querySelector(`.gif[data-gif-number="${index + 1}"]`)?.classList.add('active');

            if(!item.classList.contains('active')) {
                accordionItems.forEach(item => {
                    item.classList.remove('active');
                    item.querySelector('.accordion-header').setAttribute('aria-expanded', false);
                    item.querySelector('.accordion-content').setAttribute('aria-hidden', true);
                });
            }

            item.classList.toggle('active');
            item.querySelector('.accordion-header').setAttribute('aria-expanded', item.classList.contains('active'));
            item.querySelector('.accordion-content').setAttribute('aria-hidden', !item.classList.contains('active'));
        });
    });
};
